import ContentCurationList from './ContentCurationList'
import ContentCurationItem from './ContentCurationItem'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import IdeaIcon from '../assets/icon-content-type-idea'

const HomepageContentCurationContainer = (props) => {
  const topicType = {
    'question': <QuestionIcon />,
    'article': <ArticleIcon />,
    'answer': <AnswerIcon />,
    'discussion': <DiscussionIcon />,
    'idea': <IdeaIcon />
  }

  return <section className='topic-curation__container full-width'>
    <div className='sitewidth'>
      <div className='col'>
        <div className='box__pad'>
          <h3 className='topic-curation__widget-title m-b'>{props.title}</h3>
          {
            props.data.length ? (
              <ContentCurationList>
                { props.data.map((item, idx) => {
                  item.icon = topicType[item.type]
                  item.idx = idx
                  return <ContentCurationItem {...item} />
                })}
              </ContentCurationList>
            ) : null
          }
        </div>
      </div>
    </div>
  </section>
}

export default HomepageContentCurationContainer
